export const READ_SCOPE: string = "api://propayabackend/Read";
export const WRITE_SCOPE: string = "api://propayabackend/Write";
export const USER_IMPERSONATION_SCOPE: string = "api://propayafunctionsdev/user_impersonation";
export const USER_READWRITE_MS_GRAPH_SCOPE: string = "https://graph.microsoft.com/User.ReadWrite";